import type { LlmProvider } from '@intone/shared/types';
import { MODEL_OPTIONS, DEFAULT_PROVIDER } from '../config/constants';

export function getProviderForModel(model: string): LlmProvider {
  const found = MODEL_OPTIONS.find((m) => m.value === model)
  return found?.provider ?? DEFAULT_PROVIDER;
}